// extracted by mini-css-extract-plugin
module.exports = {"weddingSeperviseGoodsWrap":"weddingSuperviseGoods_style_weddingSeperviseGoodsWrap__2gtVq"};